module.exports = __webpack_public_path__ + "img/61.6ee906c4.jpg";